"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import BrainMobileAbout from "./BrainMobileAbout";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveLeaderboard from "../my-stream/MyStreamWaveLeaderboard";
import MyStreamWaveOutcome from "../my-stream/MyStreamWaveOutcome";
import MyStreamWaveSales from "../my-stream/MyStreamWaveSales";
import MyStreamWaveMyVotes from "../my-stream/votes/MyStreamWaveMyVotes";
import MyStreamWaveFAQ from "../my-stream/MyStreamWaveFAQ";
import BrainMobileWaves from "./BrainMobileWaves";
import BrainMobileMessages from "./BrainMobileMessages";
import BrainNotifications from "../notifications/NotificationsContainer";
import { WaveWinners } from "@/components/waves/winners/WaveWinners";
import { BrainView } from "./brainMobileViews";
interface BrainMobileViewContentProps {
  readonly activeView: BrainView;
  readonly activeWaveId: string | null;
  readonly children: ReactNode;
  readonly isCurationWave: boolean;
  readonly isMemesWave: boolean;
  readonly isRankWave: boolean;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
  readonly wave: ApiWave | null | undefined;
}
export default function BrainMobileViewContent(t0) {
  const $ = _c(34);
  const {
    activeView,
    activeWaveId,
    children,
    isCurationWave,
    isMemesWave,
    isRankWave,
    onDropClick,
    onOpenQuickVote,
    onPrefetchQuickVote,
    wave
  } = t0;
  const rankWave = isRankWave ? wave ?? null : null;
  const curationWave = isCurationWave ? wave ?? null : null;
  const faqWave = isRankWave && isMemesWave ? wave ?? null : null;
  let t1;
  if ($[0] !== onDropClick || $[1] !== rankWave) {
    t1 = rankWave ? <MyStreamWaveLeaderboard key={rankWave.id} wave={rankWave} onDropClick={onDropClick} /> : null;
    $[0] = onDropClick;
    $[1] = rankWave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const leaderboardContent = t1;
  let t2;
  if ($[3] !== curationWave) {
    t2 = curationWave ? <MyStreamWaveSales waveId={curationWave.id} /> : null;
    $[3] = curationWave;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const salesContent = t2;
  let t3;
  if ($[5] !== onDropClick || $[6] !== rankWave) {
    t3 = rankWave ? <div className="tw-px-2 sm:tw-px-4"><WaveWinners wave={rankWave} onDropClick={onDropClick} /></div> : null;
    $[5] = onDropClick;
    $[6] = rankWave;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const winnersContent = t3;
  let t4;
  if ($[8] !== rankWave) {
    t4 = rankWave ? <MyStreamWaveOutcome wave={rankWave} /> : null;
    $[8] = rankWave;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const outcomeContent = t4;
  let t5;
  if ($[10] !== onDropClick || $[11] !== rankWave) {
    t5 = rankWave ? <MyStreamWaveMyVotes wave={rankWave} onDropClick={onDropClick} /> : null;
    $[10] = onDropClick;
    $[11] = rankWave;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const myVotesContent = t5;
  let t6;
  if ($[13] !== faqWave) {
    t6 = faqWave ? <MyStreamWaveFAQ wave={faqWave} /> : null;
    $[13] = faqWave;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const faqContent = t6;
  let t7;
  if ($[15] !== children) {
    t7 = <>{children}</>;
    $[15] = children;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== activeWaveId) {
    t8 = <BrainMobileAbout activeWaveId={activeWaveId} />;
    $[17] = activeWaveId;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onOpenQuickVote || $[20] !== onPrefetchQuickVote) {
    t9 = <BrainMobileWaves onOpenQuickVote={onOpenQuickVote} onPrefetchQuickVote={onPrefetchQuickVote} />;
    $[19] = onOpenQuickVote;
    $[20] = onPrefetchQuickVote;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <BrainMobileMessages />;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <BrainNotifications />;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== faqContent || $[25] !== leaderboardContent || $[26] !== myVotesContent || $[27] !== outcomeContent || $[28] !== salesContent || $[29] !== t7 || $[30] !== t8 || $[31] !== t9 || $[32] !== winnersContent) {
    t12 = {
      [BrainView.DEFAULT]: t7,
      [BrainView.ABOUT]: t8,
      [BrainView.LEADERBOARD]: leaderboardContent,
      [BrainView.SALES]: salesContent,
      [BrainView.WINNERS]: winnersContent,
      [BrainView.OUTCOME]: outcomeContent,
      [BrainView.MY_VOTES]: myVotesContent,
      [BrainView.FAQ]: faqContent,
      [BrainView.WAVES]: t9,
      [BrainView.MESSAGES]: t10,
      [BrainView.NOTIFICATIONS]: t11
    };
    $[24] = faqContent;
    $[25] = leaderboardContent;
    $[26] = myVotesContent;
    $[27] = outcomeContent;
    $[28] = salesContent;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = winnersContent;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const contentByView = t12;
  return contentByView[activeView];
}